import { ErrorBase } from ".";

export class UpdateObjectCountExceedError extends ErrorBase {}
